export default class NotFoundErrorResponse extends Error {
  constructor(response: Response) {
    super(`NotFoundErrorResponse: ${response.status} ${response.statusText}`);
  }
}
